var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaCardPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "39px",
    viewBox: "0 0 117 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VISA card Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updated-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slide-12---Updated-Payment-Page",
    transform: "translate(-234.000000, -1254.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Elements",
    transform: "translate(0.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Cards",
    transform: "translate(208.000000, 1095.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VISA-card-Icon",
    transform: "translate(26.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7209458,37.3659151 L41.1741017,37.3659151 L47.1403232,0.655796305 L56.6882795,0.655796305 L50.7209458,37.3659151 Z M33.1425856,0.655796305 L24.0411644,25.9050675 L22.9662548,20.4683045 L22.9662548,20.4683045 L19.7526473,3.96149958 C19.7526473,3.96149958 19.3633888,0.655796305 15.2239021,0.655796305 L0.177390684,0.655796305 L0,1.27763372 C0,1.27763372 4.60159221,2.23571983 9.98670627,5.47350533 L18.28125,37.3692553 L28.2284743,37.3692553 L43.4173432,0.655796305 L33.1425856,0.655796305 Z M108.233341,37.3659151 L117,37.3659151 L109.356074,0.654682899 L101.68212,0.654682899 C98.1381987,0.654682899 97.2746008,3.39087886 97.2746008,3.39087886 L83.0388593,37.3659151 L92.9927567,37.3659151 L94.98298,31.9102243 L107.119506,31.9102243 L108.23779,37.3659151 L108.233341,37.3659151 Z M97.7278089,24.3802575 L102.74424,10.642494 L105.566364,24.3802575 L97.7278089,24.3802575 Z M83.7828992,9.48399478 L85.1453042,1.60052154 C85.1453042,1.60052154 80.9413118,0 76.5588165,0 C71.8209838,0 60.5708555,2.07316251 60.5708555,12.1528297 C60.5708555,21.6368244 73.7750618,21.7542888 73.7750618,26.7384521 C73.7750618,31.7226153 61.93048,30.8274367 58.0223241,27.6848474 L56.6031987,35.9273942 C56.6031987,35.9273942 60.8661359,38 67.3789876,38 C73.8918394,38 83.7222861,34.6230387 83.7222861,25.4318698 C83.7222861,15.8871944 70.3990779,14.9986961 70.3990779,10.8462474 C70.3990779,6.69379862 79.6979087,7.22767694 83.7828992,9.48232468 L83.7828992,9.48399478 Z",
    id: "Shape",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,21 L19.7816707,4.33670488 C19.7816707,4.33670488 19.3918402,1 15.2462712,1 L0.177651332,1 L0,1.62766914 C0,1.62766914 7.24305085,3.14486401 14.1898305,8.81692515 C20.8325424,14.2406159 23,21 23,21 Z",
    id: "Path",
    fill: "#E6A540"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardPayment);
export default __webpack_public_path__ + "static/media/visa_card_payment.82b87c1983d03afca447225c0fc98a56.svg";
export { ForwardRef as ReactComponent };